import currentDateFilter from './currentDateFilter';
import useGeneralApiCall from '../apiCalls/useGeneralApiCall';
import getAppSite from 'utils/getAppSite';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const useCallContentRelated = () => {
  const { generalApiCall } = useGeneralApiCall();

  const callContentRelated = async ({ objectId, objectType, source }) => {
    try {
      const pathname = '/api/search/more-like-this';
      const method = 'post';
      const requestProperties = {
        objectId: objectId,
        objectType: objectType,
        maxResultsPerResultsType: 3,
        resultTypes: [
          { type: 'KeyUpdate' },
          { type: 'Legislation' },
          ...(getAppSite() === 'usa'
            ? [
                {
                  type: 'CongressionalRecord',
                  filters: [{ field: 'contentType', value: 'CREC', operator: 'STR_EQ' }],
                  collapseField: 'contentUrl',
                },
              ]
            : [
                {
                  type: 'ParliamentaryRecord',
                  filters: [
                    { field: 'contentType', value: 'QuestionAndAnswer', operator: 'STR_EQ' },
                    { field: 'contentType', value: 'Edm', operator: 'STR_EQ' },
                    { field: 'contentType', value: 'ScotlandQuestionAndAnswer', operator: 'STR_EQ' },
                    { field: 'contentType', value: 'WalesQuestionAndAnswer', operator: 'STR_EQ' },
                    { field: 'contentType', value: 'NorthernIrelandQuestionAndAnswer', operator: 'STR_EQ' },
                  ],
                  collapseField: 'contentUrl',
                },
                { type: 'HansardContent' },
                { type: 'LibraryArticle' },
                { type: 'Consultation', filters: [currentDateFilter] },
                { type: 'CountrySpecificParliamentaryRecord' },
                { type: 'SeneddCommitteeTranscript' },
                { type: 'CommitteePublication' },
                {
                  type: 'RealtimeUtterance',
                  filters: [
                    {
                      field: 'dateTimeTimestamp',
                      value: `${dayjs().unix()}`,
                      operator: 'NUM_GTE',
                    },
                  ],
                },
              ]),
        ],
      };
      const contentRelated = await generalApiCall({
        pathname,
        method,
        requestProperties,
        requestSource: source,
        notShowErrorMessage: true,
      });
      return contentRelated;
    } catch (error) {
      console.error(error);
    }
  };

  return { callContentRelated };
};

export { useCallContentRelated };
